import React from 'react';
import { Button, Tooltip, Tag, Table, Empty} from 'antd';


export default function ResultList(props) {
    return (

    <Table
    bordered={props.bordered === undefined ? false : props.bordered}
    style={{ overflowX: 'auto' }}
    title={() => (
        <div style={{ width: '100%', textAlign: "right" }} hidden={true}>
            <div className="custom-options">
                {
                    props.onExportExcel === undefined ? null :
                        <Button ghost
                            type="success"
                            icon="file-excel"
                            onClick={props.onExportExcel}
                            style={{ color: '#3fb703' }}
                            loading={props.loadingExcel}
                        >
                            Excel
                        </Button>
                }
                {
                    props.onExportPdf === undefined ? null :
                        <Button ghost
                            type="danger"
                            icon="file-pdf"
                            onClick={props.onExportPdf}
                            style={{ color: '#ff4d4f' }}
                            loading={props.loadingPdf}
                        >
                            Pdf
                        </Button>
                }
                {
                    props.onExportPdfRegistrado === undefined ? null :
                        <Button ghost
                            type="danger"
                            icon="file-pdf"
                            onClick={props.onExportPdfRegistrado}
                            style={{ color: '#ff4d4f' }}
                            loading={props.loadingPdfRegistrado}
                        >
                            Pdf - Registrados
                        </Button>
                }
                {
                    props.onPrint === undefined ? null :
                        <Button ghost
                            type="primary"
                            icon="printer"
                            onClick={props.onPrint}
                            style={{ color: '#1890ff' }}
                            loading={props.loadingPrint}
                        >
                            Imprimir
                        </Button>
                }
                  {
                    props.onExportPLE === undefined ? null :
                        <Button
                            icon="file"
                            onClick={props.onExportPLE}
                            style={{ color: '#fffff' }}
                            loading={props.loadingPLE}
                        >
                            PLE
                        </Button>
                }
            </div>
        </div>
    )}


    loading={
        props.pagination.loading ? {
            tip: "Un momento por favor",
            size: "large"
        } : false
    }
    size="small"
    rowKey='idCuentasCobrarDetalle'
    dataSource={props.pagination.data}
    onChange={(pagination, filters, sorter) => {
        props.onChange({
            page: pagination.current,
            order: sorter.order,
            field: sorter.field
        })
    }}


    rowSelection={{
        onChange: props.onChangeRow,
        //selectedRowKeys: this.props.formValues.selectedRowKeys,
        hideDefaultSelections: false
    }}
    locale={{
        emptyText: <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="No se encontraron datos."
        />
    }}
    pagination={{
        total: props.pagination.total,
        current: props.pagination.page,
        pageSize: props.pagination.pageSize,
        showTotal: (total) => `${total} Registro(s) encontrado(s).`
    }}

    columns={[
        {
            title: 'Opciones',
            width: "100px",
            key: 'options',
            align: 'center',
            render: (value, row) => (
                <div className="custom-options"> 
                    <Tooltip placement="top" title="Agregar Pago">
                        <Button
                        disabled={row.idCuentasEstado==1}
                            type="primary"
                            icon="plus"
                            size={"small"}
                            onClick={() => props.onViewPago(row)}
                        />
                    </Tooltip>
         
                </div>
            )
        },
    
        {
            title: 'Fecha',
            dataIndex: 'fechaStr',
            key: 'fecha',
            sorter: true
        },
        {
            title: 'Comprobante',
            dataIndex: 'serieDocumentoComprobante',
            key: 'comprobante',
            sorter: true
        },
        {
            title: 'Tipo Comprobante',
            dataIndex: 'nombreTipoComprobante',
            key: 'tipoComprobante',
            sorter: true
        },
        {
            title: 'Cuota',
            dataIndex: 'couta',
            key: 'couta',
            sorter: true
        },
      
   
        {
            title: 'Moneda',
            dataIndex: 'moneda',
            key: 'moneda',
            sorter: true
        },
        {
            title: 'Monto',
            dataIndex: 'montoCuotaStr',
            key: 'monto',
            sorter: true

        },

        {
            title: 'Estado',
            dataIndex: 'idCuentasEstado',
            key: 'flag',
            align: 'center',
            width: "90px",
 
            render: (value,row) => {
                return (<div className="custom-options" >
                    {(() => {
                        switch (value) {
                            case 2: //registado
                                return <Tag color={"red"}>{row.nombreCuentasEstado}</Tag>;
                            case 1://ANULADA
                                return <Tag color={"green"}>{row.nombreCuentasEstado}</Tag>;
                       
                            default:
                                return null;
                        }
                    })()}

                </div>)
            }
        }
    ]}
/>
    );
}